const districtAdmins = {
  all_district_admins: '🏛️ All district administrators',
  create: 'Create New District Administrator',
  firstname: 'First Name',
  lastname: 'Last Name',
  lastname2nd: 'Second Last Name',
  email: 'Email',
  dni: 'DNI',
  birth_date: 'Birth Date',
  school_group: 'School Group (District)',
  search_school_group: 'Search school group...',
  general_information: 'General Information',
  select_school_group: 'Select School Group',
  search_by_name: 'Search by name',
};

export default districtAdmins;
